
import { formatContract } from '@shootsta/contract-and-credit-utilities';
import _get from 'lodash.get';


export default async function contractBalanceForSubscription(
orgId,
getContractBalance,
flags,
creditType)
{
  const { subscriptionsV22 = false } = flags || {};

  if (!subscriptionsV22) {
    return { teamCredits: [], orgCredits: {} };
  }

  const contractsResponse = await getContractBalance({
    organisationId: orgId,
    owners: ['WORKSPACE', 'TEAMS'],
    types: ['WORKSPACE|CREDITS', 'WORKSPACE|TOPUP_CREDITS', 'WORKSPACE|BUFFER_CREDITS']
  });

  const contractItemBalance = _get(contractsResponse, 'data.getContractItemBalance', []);

  return formatContract(contractItemBalance, creditType);
}